/* eslint no-unused-vars: 0 */
import $ from 'jquery';

import initCookiePopup from './cookie-popup';
import initScrollTo from './scroll-to';
import mobileMenu from './mobile-menu';
import categoryFilter from './category-filter';
import stickyHeader from './sticky-header';
import initVideo from './video';
import truncateText from './truncate-text';

import 'Styles/main.scss';

$(document).ready(() => {
    const $cookiePopup = $('.js-cookie-popup');
    if ($cookiePopup.length) {
        $cookiePopup.map((i, v) => initCookiePopup(v));
    }

    const $categoryFilter = $('.js-category-filter');
    if ($categoryFilter.length) {
        $categoryFilter.map((i, v) => categoryFilter(v));
    }

    const $header = $('.header');
    if ($header.length) {
        $header.map((i, v) => stickyHeader(v));
    }

    const $jsScrollTo = $('.js-scroll-to');
    if ($jsScrollTo.length) {
        $jsScrollTo.map((i, v) => initScrollTo(v));
    }

    const $jsMobileMenu = $('.js-toggle-menu');
    if ($jsMobileMenu.length) {
        $jsMobileMenu.map((i, v) => mobileMenu(v));
    }

    const $jsPlay = $('.js-play');
    if ($jsPlay.length) {
        $jsPlay.map((i, v) => initVideo(v));
    }

    const $jsTruncateText = $('.js-truncate-text');
    if ($jsTruncateText.length) {
        $jsTruncateText.map((i, v) => truncateText(v));
    }
});
